module.exports = __webpack_public_path__ + "img/kitchen.3b5698b2.svg";